<template>
  <span
    class="inline-flex items-center py-0.5 px-2.5 text-xs font-medium rounded-full"
    :class="[`bg-${variant}-100 text-${variant}-800 dark:bg-${variant}-400 dark:text-${variant}-900`]"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: "UiBadge",
  props: {
    variant: {
      type: String,
      default: 'blue'
    }
  }
}
</script>
